/**
 * Relative time for past/future ISO timestamps (e.g. activity feed).
 * Uses Intl.RelativeTimeFormat; no extra dependencies.
 */
export function formatRelativeTime(iso: string, locale: string): string {
  const date = new Date(iso);
  const now = Date.now();
  const diffMs = date.getTime() - now;
  const diffSec = Math.round(diffMs / 1000);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  const abs = Math.abs(diffSec);

  if (abs < 45) {
    return rtf.format(Math.round(diffSec), 'second');
  }
  if (abs < 3600) {
    return rtf.format(Math.round(diffSec / 60), 'minute');
  }
  if (abs < 86400) {
    return rtf.format(Math.round(diffSec / 3600), 'hour');
  }
  if (abs < 604800) {
    return rtf.format(Math.round(diffSec / 86400), 'day');
  }
  if (abs < 2628000) {
    return rtf.format(Math.round(diffSec / 604800), 'week');
  }
  if (abs < 31536000) {
    return rtf.format(Math.round(diffSec / 2628000), 'month');
  }
  return rtf.format(Math.round(diffSec / 31536000), 'year');
}
